export const enData = {
  "HOME": "HOME",
  "STAGES": "STAGES",
  "NFTS": "NFTs RWA",
  "CALCULATOR": "CALCULATOR",
  "BLOG": "Blog"
};